<template>
    <div class="hero-section">
        <div class="hero-image">
            <img :src="a58" alt="Feedback">
        </div>
        <div class="hero-content">
            <h1 class="hero-title fuente-posm">
                Cada ticket se convierte en<br>
                <span>feedback Instantáneo</span>
            </h1>
            <p class="hero-text fuente-nova">
                Nuestro QR dinámico se imprime automáticamente en cada ticket de venta, revolucionando la forma de obtener feedback. Cada encuesta ya conoce toda la experiencia: qué productos se ordenaron, el horario de visita y el mesero que brindó el servicio.
                <br><br>
                Elimina preguntas innecesarias y obtén insights precisos que conectan directamente la experiencia del cliente con tus datos operativos en tiempo real.
            </p>
        </div>
    </div>
</template>

<script>
export default {
    name: 'FeedbackHeroNew',
    data() {
        return {
            a58: require('@/assets/images/a58.webp')
        }
    }
}
</script>

<style lang="css" scoped>
.hero-section {
    width: 100vw;
    height: 100vh;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    padding: 40px 60px;
    box-sizing: border-box;
    scroll-snap-align: start;
    gap: 40px;
}

.hero-image {
    flex: 0 0 auto;
    display: flex;
    justify-content: center;
    align-items: center;
    order: 1;
}

.hero-image img {
    width: 350px;
    height: auto;
}

.hero-content {
    flex: 1;
    max-width: 750px;
    order: 2;
}

.hero-title {
    color: var(--color-2);
    font-size: 68px;
    line-height: 1.1;
    margin: 0 0 20px 0;
}

.hero-text {
    color: var(--color-3);
    font-size: 29px;
    line-height: 1.3;
    margin: 0 0 40px 0;
    padding-left: 10px;
}

/* Tablet */
@media (max-width: 992px) and (min-width: 769px) {
    .hero-title {
        font-size: 60px;
    }

    .hero-text {
        font-size: 27px;
    }

    .hero-image img {
        width: 280px;
    }
}

/* Mobile */
@media (max-width: 768px) {
    .hero-section {
        flex-direction: column;
        justify-content: flex-start;
        height: 100vh;
        padding: 100px 20px 40px 20px;
        gap: 20px;
    }

    .hero-image {
        order: 2;
        width: 100%;
        flex: 1;
        display: flex;
        align-items: flex-start;
        justify-content: center;
        padding-top: 20px;
    }

    .hero-image img {
        width: 50%;
        max-width: 180px;
    }

    .hero-content {
        order: 1;
        max-width: 100%;
        flex: none;
    }

    .hero-title {
        font-size: 24px;
        line-height: 1.2;
        margin: 0 0 10px 0;
    }

    .hero-text {
        font-size: 16px;
        padding-left: 10px;
        margin: 0 0 20px 0;
    }
}
</style>
